import { TransferDirection } from './transfer-direction.enum';

export interface TransferSearchChangeModeConfig {
    direction: TransferDirection;
    value: string;
}